// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ToggleMerlinSourcingEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleMerlinSourcingEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleMerlinSourcingEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);

export type ToggleMerlinGraphQlApiEnabledMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type ToggleMerlinGraphQlApiEnabledMutation = (
  { __typename?: 'Mutation' }
  & { toggleMerlinGraphQLApiEnabled?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message'>
  )> }
);


export const ToggleMerlinSourcingEnabledDocument = gql`
    mutation ToggleMerlinSourcingEnabled($siteId: UUID!) {
  toggleMerlinSourcingEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleMerlinSourcingEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleMerlinSourcingEnabledMutation, ToggleMerlinSourcingEnabledMutationVariables>;

/**
 * __useToggleMerlinSourcingEnabledMutation__
 *
 * To run a mutation, you first call `useToggleMerlinSourcingEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMerlinSourcingEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMerlinSourcingEnabledMutation, { data, loading, error }] = useToggleMerlinSourcingEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleMerlinSourcingEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleMerlinSourcingEnabledMutation, ToggleMerlinSourcingEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleMerlinSourcingEnabledMutation, ToggleMerlinSourcingEnabledMutationVariables>(ToggleMerlinSourcingEnabledDocument, baseOptions);
      }
export type ToggleMerlinSourcingEnabledMutationHookResult = ReturnType<typeof useToggleMerlinSourcingEnabledMutation>;
export type ToggleMerlinSourcingEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleMerlinSourcingEnabledMutation>;
export type ToggleMerlinSourcingEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleMerlinSourcingEnabledMutation, ToggleMerlinSourcingEnabledMutationVariables>;
export const ToggleMerlinGraphQlApiEnabledDocument = gql`
    mutation ToggleMerlinGraphQLApiEnabled($siteId: UUID!) {
  toggleMerlinGraphQLApiEnabled(siteId: $siteId) {
    success
    message
  }
}
    `;
export type ToggleMerlinGraphQlApiEnabledMutationFn = ApolloReactCommon.MutationFunction<ToggleMerlinGraphQlApiEnabledMutation, ToggleMerlinGraphQlApiEnabledMutationVariables>;

/**
 * __useToggleMerlinGraphQlApiEnabledMutation__
 *
 * To run a mutation, you first call `useToggleMerlinGraphQlApiEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleMerlinGraphQlApiEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleMerlinGraphQlApiEnabledMutation, { data, loading, error }] = useToggleMerlinGraphQlApiEnabledMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useToggleMerlinGraphQlApiEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ToggleMerlinGraphQlApiEnabledMutation, ToggleMerlinGraphQlApiEnabledMutationVariables>) {
        return ApolloReactHooks.useMutation<ToggleMerlinGraphQlApiEnabledMutation, ToggleMerlinGraphQlApiEnabledMutationVariables>(ToggleMerlinGraphQlApiEnabledDocument, baseOptions);
      }
export type ToggleMerlinGraphQlApiEnabledMutationHookResult = ReturnType<typeof useToggleMerlinGraphQlApiEnabledMutation>;
export type ToggleMerlinGraphQlApiEnabledMutationResult = ApolloReactCommon.MutationResult<ToggleMerlinGraphQlApiEnabledMutation>;
export type ToggleMerlinGraphQlApiEnabledMutationOptions = ApolloReactCommon.BaseMutationOptions<ToggleMerlinGraphQlApiEnabledMutation, ToggleMerlinGraphQlApiEnabledMutationVariables>;
